import { API_URL, ROUTE_PATH } from "common/constants/sm-constants";
import {
  FormMetaModel,
  SmDatepickerModel,
  SmMetaSelectModel,
} from "common/models/utility-models/meta-model";

export class DashboardFilterMetaModel extends FormMetaModel {
  constructor() {
    super(
      "",
      ROUTE_PATH.adminDashboard,
      ROUTE_PATH.adminDashboard,
      3,
      null,
      false,
      "",
      "",
      "row align-items-start"
    );
  }

  override initProperties(): any {
    const formInfo = super.initProperties();

    const selectedFromDate = new SmDatepickerModel(
      "selectedFromDate",
      "selectedFromDate",
      "datepicker",
      false,
      "col-2-4 pt-2",
      1,
      9,
      "Start date",
      "text",
      "",
      false,
      true,
      true,
      false,
      false,
      "DD/MM/YYYY",
      new Date("1970-10-19"),
      new Date("2040-01-01"),
      [],
      false,
      null,
      false,
      {
        isPlaceholder: true,
        placeholderLabel: "",
        isIconVisible: true,
      }
    );

    const selectedToDate = new SmDatepickerModel(
      "selectedToDate",
      "selectedToDate",
      "datepicker",
      false,
      "col-2-4 pt-2",
      1,
      10,
      "End date",
      "text",
      "",
      true,
      true,
      true,
      false,
      false,
      "DD/MM/YYYY",
      new Date("1970-10-19"),
      new Date("2040-01-01"),
      [],
      false,
      null,
      false,
      {
        isPlaceholder: true,
        placeholderLabel: "",
        isIconVisible: true,
      }
    );

    // const selectedYearRange = new SmDatepickerModel(
    //   "selectedYearRange",
    //   "selectedYearRange",
    //   "datepicker",
    //   false,
    //   "col-2-4 pt-2",
    //   1,
    //   10,
    //   "End date",
    //   "text",
    //   "",
    //   true,
    //   true,
    //   true,
    //   false,
    //   false,
    //   "DD/MM/YYYY",
    //   new Date("1970-10-19"),
    //   new Date("2040-01-01"),
    //   [],
    //   false,
    //   null,
    //   false,
    //   {
    //     isPlaceholder: true,
    //     placeholderLabel: "",
    //     isIconVisible: true,
    //   }
    // );

    const selectedYearRange = new SmDatepickerModel(
      "selectedYearRange",
      "selectedYearRange",
      "datepicker",
      false,
      "col-2-4 pt-2",
      1,
      9,
      "Select Year",
      "text",
      "",
      false,
      true,
      true,
      false,
      false,
      "YYYY",
      new Date("1970-10-19"),
      new Date("2040-01-01"),
      [],
      false,
      null,
      false,
      {
        isPlaceholder: true,
        placeholderLabel: "",
        isIconVisible: true,
      }
    );
    // const buttons = {
    //     // submit: new SmBtnMetaModel('Submit', '', true, false, false, true),
    //     isFormControl: false,
    // };

    return {
      formInfo,
      selectedFromDate,
      selectedToDate,
      selectedYearRange
    };
  }
}

export class DashboardCountMetaModel {
  countItems: any[] = [
    {
      id: 1,
      label: "Students",
      key: "studentCount",
      iconUrl: "assets/dashboard/students-icon.svg",
      apiUrl: API_URL.getDashboardData,
    },
    {
      id: 1,
      label: "Assignments",
      key: "assignmentCount",
      iconUrl: "assets/dashboard/assignment-icon.svg",
      apiUrl: API_URL.getDashboardData,
    },
    {
      id: 1,
      label: "Internships",
      key: "internshipCount",
      iconUrl: "assets/dashboard/internship-icon.svg",
      apiUrl: API_URL.getDashboardData,
    },
    {
      id: 1,
      label: "Mentoring",
      key: "mentorsTotalCount",
      iconUrl: "assets/dashboard/mentor-icon.svg",
      apiUrl: API_URL.getDashboardData,
    },
    {
      id: 1,
      label: "Applicants",
      key: "applicantCount",
      iconUrl: "assets/dashboard/applicant-icon.svg",
      apiUrl: API_URL.getDashboardData,
    },
    // {
    //   id: 1,
    //   label: "SSP Hub",
    //   key: "ssphubCount",
    //   iconUrl: "assets/dashboard/socialwall-icon.svg",
    //   apiUrl: API_URL.getDashboardData,
    // },
  ];
}
